<div class="row" style="min-height: 300px;">

  <div class="col-12">
    <div class="tablewrap">
      <div class="d-flex flex-row bb" *ngPermissions="[permissionService.Permission.ssp_list]">
        <div
          class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
          <p class="w-100">{{'lang.globals.ssp' | translate}}<span class="red">*</span></p>
          <div ngbDropdown placement="bottom-right" class="w-100 tr" style="margin-top: -14px;">
            <button class="btn btn-outline-primary" ngbDropdownToggle [disabled]="editMode">
              <sb-value-definition [text]="getSSPText()"></sb-value-definition>
            </button>
            <div ngbDropdownMenu class="scrollable-menu">
              <button ngbDropdownItem *ngFor="let sspEle of SSPs"
                      (click)="setSSP(sspEle)"
                      [ngClass]="sspEle === ssp ? 'active' : ''">{{sspEle.name}}</button>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-row bb">
        <div
          class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
          <p class="w-100">{{'lang.globals.identifier' | translate}}<span class="red">*</span></p>
          <p class="w-100 tr" style="margin: -20px; margin-right: 0;">
            <input type="text" class="form-control text-end" placeholder="..." [ngModel]="identifier"
                   (ngModelChange)="onIdentifier($event)">
          </p>
        </div>
      </div>
      <div class="d-flex flex-row bb">
        <div
          class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
          <p class="w-100">{{'lang.globals.name' | translate}}<span class="red">*</span></p>
          <p class="w-100 tr" style="margin: -20px; margin-right: 0;">
            <input type="text" class="form-control text-end" placeholder="..." [ngModel]="name"
                   (ngModelChange)="onName($event)">
          </p>
        </div>
      </div>
      <div class="d-flex flex-row bb">
        <div
          class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
          <p class="w-100">{{'lang.globals.screenIdPrefix' | translate}}</p>
          <p class="w-100 tr" style="margin: -20px; margin-right: 0;">
            <input type="text" class="form-control text-end" placeholder="..." [ngModel]="prefix"
                   (ngModelChange)="onPrefix($event)">
          </p>
        </div>
      </div>
      <div class="d-flex flex-row bb">
        <div
          class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
          <p class="w-100">{{'lang.globals.screenIdSuffix' | translate}}</p>
          <p class="w-100 tr" style="margin: -20px; margin-right: 0;">
            <input type="text" class="form-control text-end" placeholder="..." [ngModel]="suffix"
                   (ngModelChange)="onSuffix($event)">
          </p>
        </div>
      </div>
      <div class="d-flex flex-row bbl">
        <div
          class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
        </div>
      </div>
      <div class="d-flex flex-row">
        <div
          class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
          <p class="w-100 tr"></p>
          <p class="w-100 tr">
            <button class="btn btn-primary mr-2" [disabled]="!(ssp&&name&&identifier)"
                    (click)="ok()">{{ 'lang.globals.ok' | translate }}</button>
            <button class="btn btn-secondary"
                    (click)="cancel()">{{ 'lang.globals.cancel' | translate }}</button>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
